module.exports = __webpack_public_path__ + "img/Picture11.07909bb8.jpg";